import { KlevuTypeOfRecord } from "../../models/KlevuTypeOfRecord.js";
import { KlevuTypeOfRequest } from "../../models/KlevuTypeOfRequest.js";
import { KlevuLastClickedProducts } from "../../store/lastClickedProducts.js";
const defaultOptions = {
    id: "recentlyViewedProducts",
    /**
     * The number of products to return
     */
    amount: 10,
    /**
     * List of string ids for last clicked products
     */
    lastClickedProductIds: [],
};
/**
 * Recently viewed products
 *
 * @category RecommendationQuery
 * @param {Options} options Allows to override amount of products to return or pass custom lastClickedProductIds
 * @param modifiers
 * @returns
 */
export function recentlyViewed(options, ...modifiers) {
    const opts = Object.assign(Object.assign({}, defaultOptions), options);
    const lastProducts = opts.lastClickedProductIds && opts.lastClickedProductIds.length > 0
        ? opts.lastClickedProductIds
        : KlevuLastClickedProducts.getLastClickedLatestsFirst(opts.amount);
    const query = {
        id: opts.id,
        typeOfRequest: KlevuTypeOfRequest.Search,
        settings: {
            limit: lastProducts.length,
            typeOfRecords: [KlevuTypeOfRecord.Product],
            customANDQuery: `id:(${lastProducts.join(" OR ")})`,
            topIds: lastProducts.map((id) => ({ key: "id", value: id })),
        },
    };
    return {
        klevuFunctionId: "recommendation",
        queries: [query],
        modifiers,
    };
}
